/* eslint-disable no-nested-ternary */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { bool, func, string, object } from 'prop-types';
import Button from 'components/Button';
import Modal from 'components/Modal';

export default function ModalClienteNaoCadastrado({ 
  open, 
  message, 
  cpfCnpj,
  dadosTomador,
  onClose,
  onCancel 
}) {
  const history = useHistory();

  if (!open) return null;

  const handleCadastrarCliente = () => {
    // Fechar o modal
    onClose();
    
    // Navegar para o cadastro de cliente com dados pré-preenchidos
    history.push({
      pathname: '/financeiro/clientes/new',
      state: {
        dadosPreenchidos: dadosTomador || {},
        returnTo: history.location.pathname, // Voltar para a tela de viagem após cadastrar
        cpfCnpj: cpfCnpj,
      },
    });
  };

  const handleCancelar = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleCancelar}
      title="Cadastrar Tomador como Cliente"
    >
      <div style={{ padding: '20px', minWidth: '400px' }}>
        <p style={{ marginBottom: '20px', color: '#666' }}>
          {message || 'O tomador não está cadastrado como cliente. Deseja cadastrá-lo agora?'}
        </p>
        <div style={{ marginBottom: '15px' }}>
          <strong>Nome:</strong> {dadosTomador?.nome || '-'}
        </div>
        <div style={{ marginBottom: '15px' }}>
          <strong>CPF/CNPJ:</strong> {dadosTomador?.cpfCnpj || cpfCnpj || '-'}
        </div>
        {dadosTomador?.email && (
          <div style={{ marginBottom: '15px' }}>
            <strong>E-mail:</strong> {dadosTomador.email}
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <Button
            label="Cancelar"
            onClick={handleCancelar}
            color="secondary"
          />
          <Button
            label="Cadastrar Cliente"
            onClick={handleCadastrarCliente}
            color="primary"
          />
        </div>
      </div>
    </Modal>
  );
}

ModalClienteNaoCadastrado.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  message: string,
  cpfCnpj: string,
  dadosTomador: object,
  onCancel: func,
};

